export default "__VITE_ASSET__DXevJh6x__"